<template>
  <div id="app">
    <nav-bar />
    <aside-menu :menu="menu" />
    <router-view style="min-height: 100vh;"/>
    <footer-bar />
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import menu from '@/menu.js'
import NavBar from '@/components/NavBar.vue'
import AsideMenu from '@/components/AsideMenu.vue'
import FooterBar from '@/components/FooterBar.vue'

export default defineComponent({
  name: 'AppComponent',
  components: {
    FooterBar,
    AsideMenu,
    NavBar
  },
  data () {
    return {
      menu
    }
  },
  created () {
    this.$store.commit('user', {
      name: 'Priscila Brito',
      email: 'claudiny.brito@emap.ma.gov.br',
      empresa:'EMAP',
      avatar: 'https://api.dicebear.com/6.x/big-ears-neutral/svg?seed=Annie'
      //avatar: 'https://avatars.dicebear.com/v2/gridy/Gizmo.svg'
    })
  }
})
</script>
